import React, {ReactElement, useEffect, useState} from "react";
import {StyledBoxColumn, StyledBoxRow} from "../shared/StyledComponents";
import {PD_MD, PD_XLG, PD_XLG2} from "../shared/dimens";
import {Button, TextField, Typography} from "@mui/material";
import {COLOR_BG2} from "./App";
import Markdown from "react-markdown";
import {NewGameHelper} from "./EditGameHelper";
import {genGuestName} from "./usernamegen";
import {PathProps} from "../index";

export function CreateOrJoinPage(props: {
  path: PathProps,
  title?: string,
  text: string,
  joinRoomId?: string
}): ReactElement {
  const [nickname, setNickname] = useState<string>("");
  const [nicknamePlaceholder, setNicknamePlaceholder] = useState<string | null>(null);
  useEffect(() => {
    genGuestName().then(username => setNicknamePlaceholder(username));
  }, []);
  return <StyledBoxColumn style={{boxSizing: "border-box", width: "100%", maxWidth: 480, marginTop: 48, padding: PD_MD, gap: PD_XLG}}>
    {props.title
      ? <Typography
        style={{color: "#ccc", fontWeight: "bold", textAlign: "center", padding: PD_XLG, marginBottom: -PD_XLG}}>
        {props.title}
      </Typography>
      : null}
    <Typography component="div" style={{
      fontSize: "100%",
      paddingLeft: PD_MD,
      paddingRight: PD_MD,
      color: "white",
      background: COLOR_BG2,
      border: "1px solid black"
    }}>
      <Markdown>
        {props.text}
      </Markdown>
    </Typography>
    <StyledBoxColumn style={{color: "white"}}>
      <Typography variant="caption">Enter Nickname (or leave empty to use default):</Typography>
      <StyledBoxRow style={{alignItems: "end"}}>
        <TextField placeholder={nicknamePlaceholder} size="small" style={{flexGrow: 1}} value={nickname}
                   onChange={event => setNickname(event.target.value?.trim())}/>
        <Button
          variant="contained"
          style={{
            paddingLeft: PD_XLG2,
            paddingRight: PD_XLG2,
            fontSize: "120%",
            color: "black",
            fontWeight: "bold",
            border: "2px solid #fff",
            background: "linear-gradient(#fff, #ccc)",
          }}
          onClick={() => {
            const helper = new NewGameHelper(props.path, nickname || nicknamePlaceholder);
            if (!props.joinRoomId) {
              helper.createNewGame();
            } else {
              helper.joinAndShowNewRoom(props.joinRoomId);
            }
          }}>
          {!props.joinRoomId ? "NEW GAME" : "JOIN GAME"}
        </Button>
      </StyledBoxRow>
    </StyledBoxColumn>
  </StyledBoxColumn>;
}